import { SpinnerProps } from "../../types/SpinnerProps";

export default function Spinner(props: SpinnerProps) {
  return (
    <div
      className={
        props.visible
          ? 'd-flex justify-content-center'
          : 'd-none justify-content-center'
      }>
      <div
        className={`spinner-border ${props.marginsClass ?? 'mt-5'} `}
        role="status"
        id="modal-spinner-act-cons">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}